import { render, staticRenderFns } from "./SignupName.vue?vue&type=template&id=5619a866&scoped=true&"
import script from "./SignupName.vue?vue&type=script&lang=js&"
export * from "./SignupName.vue?vue&type=script&lang=js&"
import style0 from "./SignupName.vue?vue&type=style&index=0&id=5619a866&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5619a866",
  null
  
)

export default component.exports